import React from 'react';
import PropTypes from 'prop-types';

export default function FuelIcon({
  color, onClick, onMouseEnter, onMouseLeave,
}) {
  return (
    <svg
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      width='33'
      height='33'
      viewBox='0 0 33 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
    >
      <rect x='3' y='1' width='14' height='31' fill={color} stroke={color} strokeWidth='2' />
      <rect x='5' y='3' width='10' height='9' fill='white' stroke={color} strokeWidth='2' />
      <rect x='0.5' y='31.5' width='19' height='1' stroke={color} />
      <path d='M18 5V5C20.2091 5 22 6.79086 22 9V29C22 30.6569 23.3431 32 25 32V32C26.6569 32 28 30.6569 28 29V17.1628C28 15.7464 28.3761 14.3553 29.0898 13.1318L31.5 9' stroke={color} strokeWidth='2' />
      <path d='M28 24H31V17.5H28' stroke={color} strokeWidth='2' />
    </svg>
  );
}

FuelIcon.defaultProps = {
  color: '#a6a6a6',
  onClick: () => {},
};

FuelIcon.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
};
